import { platform } from '~/lib/params'

// The SKU a Store IAP product sells under on this platform (GLOSSARY.md "Shop
// IAP price"): Time Crystal packs and the starter pack alike. null = the
// product carries none for this platform and cannot be sold here.
export function platformSku(product: Record<string, unknown>): string | null {
  const value =
    platform === 'china_android'
      ? product.iap_sku_android_cn
      : platform === 'googleplay_android'
        ? product.iap_sku_android
        : product.iap_sku_ios
  return typeof value === 'string' && value.length > 0 ? value : null
}
